<template>
  <div class="course-list-wrapper">
    <swiper :options="courseListOption"  ref="courseListRef">
      <swiper-slide class="course-list" v-for="courses in courseList">
        <CourseItem :course="course" v-for="course in courses" prevPage="home" :path="path" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import CourseItem from '@/components/h5/CourseItem.vue'

export default {
  name: 'CourseList',
  components: {
    CourseItem,
    swiper,
    swiperSlide,
  },
  props: {
    courseList: Array,
    activeIndex: Number,
    path: String,
  },
  data() {
    const vw = this
    return {
      courseListOption: {
        autoHeight: true,
        on: {
          slideChangeTransitionEnd: function() {
            vw.$emit('on-change-menu', this.activeIndex)
          },
        },
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.courseListRef.swiper
    }
  },
  watch:{
    activeIndex: {
      handler: function(index) {
        this.swiper.slideTo(index, 500, false)
      }
    },
  }
};
</script>

<style scoped lang="scss">
.course-list-wrapper {
  background-color: #fff;

  .course-list {
    padding: 0 15px;
    box-sizing: border-box;
  }
}
</style>
